export default "__VITE_ASSET__Dv54dRre__"